<template>
	<div v-if="!props.disableInput" class="available">Available: {{ maxAmountFloat }}</div>
	<div class="container">
		<div class="select-asset" @click="modal.show()">
			<AssetAvatar :asset="selectAssetInputAmount.asset" class="asset-avatar" />
			<ChevronDownIcon class="icon-chevron" />
		</div>

		<input v-model.lazy="amountInput" type="number" class="input-amount" :disabled="props.disableInput" />
		<BaseButton v-if="!props.disableInput" variant="primary-line" @click="setMaxAmount()">MAX</BaseButton>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import { AssetAmount } from '@/libs/asset-amount';
import { Asset, WAVES } from '@/libs/asset';
import { useModal } from '@/stores/useModalStore';
import SelectAssetAmountModal from './modals/SelectAssetAmountModal.vue';
import { computed } from 'vue';
import AssetAvatar from './AssetAvatar.vue';
import ChevronDownIcon from '@/assets/icons/chevron-down.svg?component';

const min = 0;

const props = defineProps<{
	disableAutoMaxAmount?: boolean;
	disableInput?: boolean;
	assetAmounts: AssetAmount[];
}>();

const selectAssetInputAmount = defineModel<AssetAmount>({
	required: true
});

const modal = useModal({
	component: SelectAssetAmountModal,
	props: {
		assetAmounts: props.assetAmounts
	},
	onClose(assetAmount?: AssetAmount) {
		if (!assetAmount) return;

		selectAssetInputAmount.value = new AssetAmount(
			assetAmount.asset,
			selectAssetInputAmount.value.amount > assetAmount.amount
				? assetAmount.amount
				: selectAssetInputAmount.value.amount
		);
	}
});

const maxAmount = computed(() => {
	return Number(
		props.assetAmounts.find((e) => e.asset.assetId === selectAssetInputAmount.value.asset.assetId)!.amount
	);
});

const maxAmountFloat = computed(() => {
	return selectAssetInputAmount.value.asset.amountToFloat(maxAmount.value);
});

const amountInput = computed({
	get: () =>
		(
			Number(selectAssetInputAmount.value.amount) / Math.pow(10, selectAssetInputAmount.value.asset.decimals)
		).toFixed(selectAssetInputAmount.value.asset.decimals),
	set: (val) => {
		const bigAmount = parseFloat(val) * Math.pow(10, selectAssetInputAmount.value.asset.decimals);
		let nextAmount: number;

		if (isNaN(bigAmount)) nextAmount = min;
		else if (bigAmount < min) {
			nextAmount = min;
		} else if (bigAmount > maxAmount.value && !props.disableAutoMaxAmount) {
			nextAmount = maxAmount.value;
		} else nextAmount = bigAmount;

		console.log(val, nextAmount, props.disableAutoMaxAmount);

		selectAssetInputAmount.value = new AssetAmount(selectAssetInputAmount.value.asset, BigInt(nextAmount));

		console.log(selectAssetInputAmount.value);
	}
});

const setMaxAmount = () => {
	selectAssetInputAmount.value = new AssetAmount(selectAssetInputAmount.value.asset, BigInt(maxAmount.value));
};

watch(amountInput, () => {
	console.log(amountInput.value);
});
</script>

<style scoped lang="css">
.container {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 14px;
	gap: 10px;

	background: #090e1c;
	border: 1px solid #252f4a;
	border-radius: 16px;

	width: 100%;
}

.available {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 120%;
	text-align: right;

	color: #99a1b7;

	text-align: right;
}

.select-asset {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 6px 2px 2px;
	gap: 4px;

	background: rgba(255, 255, 255, 0.05);
	border-radius: 100px;

	cursor: pointer;
}

.select-asset .icon-chevron {
	width: 15px;
	height: 15px;

	stroke: rgba(37, 47, 74, 1);
}

.asset-avatar {
	width: 20px;
	height: 20px;
}

.input-amount {
	border: none;
	background-color: transparent;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 120%;

	color: #ffffff;

	width: 100%;
}

.input-amount:focus {
	outline: none;
}

.container button {
	background: transparent;
	padding: 0px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 120%;

	color: #027aff;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type='number'] {
	-moz-appearance: textfield;
}

input[disabled] {
	color: #78829d;
}
</style>
